import {
    Alert,
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text, useToast
} from '@chakra-ui/react';
import { useState } from 'react';
import { voidTransaction } from '../../api';

export default function VoidConfirmationModal({ isOpen, onClose, transactionId, onSuccess, isARB }) {
    const [loading, setLoading] = useState(false);
    const toast = useToast();

    const handleConfirm = async () => {
        setLoading(true);
        const res = await voidTransaction(transactionId);
        setLoading(false);

        if (res.success) {
            toast({
                title: 'Transaction Voided',
                status: 'success',
                duration: 3000,
                isClosable: true
            });
            onSuccess?.(); // optional callback after void
            onClose();
        } else {
            toast({
                title: 'Failed to Void Transaction',
                description: res.message || res.error,
                status: 'error',
                duration: 4000,
                isClosable: true
            });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Void Transaction</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text>Are you sure you want to void this transaction?</Text>
                    {isARB != null &&

                        <Alert flexDir={'column'} mt={3} mb={3}>
                            <Text>This transaction is part of ARB subscription, voiding this transaction won't cancel the ARB subscription.</Text>
                            <Text mt={3}>To cancel a whole subscription, you need to void/refund this transaction and go to View ARB details and cancel it from there.</Text>
                        </Alert>

                    }
                    <Text mt={3}>Voiding unsettled transaction will stop it from being charged</Text>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={onClose}>No</Button>
                    <Button colorScheme="red" ml={3} onClick={handleConfirm} isLoading={loading}>
                        Yes, Void
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
